import React from "react";
import { useNavigate } from "react-router-dom";
import SectionTitle from "../../../assets/components/TitleGroup";
import { SplitRowHalf } from "../../../assets/components/ButtonGroup";
import { useFixedLayout } from "../../../hooks/useFixedLayout";

const AdsRegistConciergeAsk = ({
  goToStep,
  targetConciergeVerify,
  targetStoreSearch,
}) => {
  const navigate = useNavigate();
  const { footerRef, bottomSpace } = useFixedLayout();

  return (
    <div className="flex h-full flex-col">
      <div
        className="flex flex-1 flex-col px-[16px] pt-[16px]"
        style={{ paddingBottom: bottomSpace }}
      >
        <SectionTitle
          title="기존 컨시어지 회원이신가요?"
          subTitle={
            "컨시어지 회원이라면 등록된 매장 정보를 확인한 뒤 앱 가입을 이어갈 수 있습니다.\n컨시어지 회원이 아닌 경우에만 직접 매장 등록으로 진행합니다."
          }
          className="pb-[40px]"
        />

        <div className="rounded-[16px] border border-border-default bg-surface-light-white-layered p-[16px]">
          <div className="pb-[8px] text-b1 text-text-subtle">안내</div>
          <ul className="space-y-[8px] text-b2 text-text-subtler">
            <li>컨시어지 회원은 본인인증한 휴대폰번호와 PIN 번호로 확인합니다.</li>
            <li>확인된 컨시어지 매장 정보는 읽기 전용으로 보여드린 뒤 앱 가입에 연결합니다.</li>
            <li>정보가 다르면 직접 등록하지 말고 고객지원으로 문의해 주세요.</li>
          </ul>
        </div>

        <div className="pt-[16px]">
          <button
            type="button"
            onClick={() => navigate("/ads/support")}
            className="text-b2 text-text-subtler underline underline-offset-[2px]"
          >
            정보가 다르면 고객지원으로 문의하기
          </button>
        </div>
      </div>

      <div ref={footerRef} className="fixed bottom-0 left-0 right-0 bg-surface-default">
        <SplitRowHalf
          leftText="아니오"
          rightText="네, 컨시어지 회원입니다"
          leftType="border"
          rightType="fill"
          onLeft={() => goToStep(targetStoreSearch)}
          onRight={() => goToStep(targetConciergeVerify)}
        />
      </div>
    </div>
  );
};

export default AdsRegistConciergeAsk;
